import { FolderObject } from "@/shared/sync/dataTypes/FolderObject"

export class FoldersManager {
    folders: FolderObject[] = []
    
    static shared = new FoldersManager()
    private constructor() {

    }
}